import React from 'react';
import { Card, Form } from 'antd';
import InputFormItem from './InputFormItem';
import SubmitFormItem from './SubmitFormItem';
import FormSteps from './FormSteps';
import dataTransform from '../../../util/dataTransform';
import Layout from './layout';
import InputTextArea from './InputTextArea';
import DateFormItem from './DateFormItem';

const text = {
  title: '请登记学生基本信息',
  studentId: '学生学号',
  studentIdPlaceholder: '请输入学生学号',
  chineseName: '中文名',
  chineseNamePlaceholder: '请输入用户名',
  chineseNameRequired: '中文名不能为空',
  englishName: '英文名',
  englishNamePlaceholder: '请输入英文名',
  englishNameRequired: '英文名不能为空',
  phone: '手机',
  phonePlaceholder: '请输入手机号码',
  email: '邮箱',
  emailPlaceholder: '请输入邮箱',
  birthday: '生日日期',
  note: '备注',
  notePlaceholder: '请输入学生更多信息',
  successTitle: '成功注册新学生',
  successDesc: '新学生尚未登记任何课程',
  successQuestion: '是否为学生登记课程？',
};

const EnrollStudent = (props) => {
  const [form] = Form.useForm();
  const {
    history,
    redirectToHome,
    redirectToCourse,
    postEnrollStudent,
    isStudentModelVisible,
    setStudentEnrollModelVisible,
  } = props;

  function handleSubmit() {
    const userInfo = form.getFieldsValue();
    console.log('** userInfo', userInfo);
    const studentData = dataTransform.enrollStudentDataTransform(userInfo);
    postEnrollStudent(studentData);
  }

  return (
    <div>
      <FormSteps currentStep={0} />
      <Card title={text.title} style={Layout.cardStyle}>
        <Form layout='horizontal' form={form}>
          <InputFormItem
            label={text.studentId}
            fieldName='student_school_id'
            placeholder={text.studentIdPlaceholder}
          />
          <InputFormItem
            label={text.chineseName}
            fieldName='cnname'
            placeholder={text.chineseNamePlaceholder}
            requireMessage={text.chineseNameRequired}
          />
          <InputFormItem
            label={text.englishName}
            fieldName='enname'
            placeholder={text.englishNamePlaceholder}
            requireMessage={text.englishNameRequired}
          />
          <InputFormItem
            label={text.phone}
            fieldName='phone'
            placeholder={text.phonePlaceholder}
          />
          <InputFormItem
            label={text.email}
            fieldName='email'
            placeholder={text.emailPlaceholder}
          />
          <DateFormItem label={text.birthday} isRequire={false} />
          <InputTextArea
            label={text.note}
            fieldName='other_info'
            placeholder={text.notePlaceholder}
          />
          <SubmitFormItem
            hasModel={true}
            handleSubmit={handleSubmit}
            isModelVisible={isStudentModelVisible}
            setModelVisible={setStudentEnrollModelVisible}
            ToHome={() => redirectToHome(history)}
            handleRedirect={() => redirectToCourse(history)}
            instructions={[
              text.successTitle,
              text.successDesc,
              text.successQuestion,
            ]}
          />
        </Form>
      </Card>
    </div>
  );
};

export default EnrollStudent;
